import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
avatar07,

  logo,
  logoSmall,
  logoSmallWhite,
  search,
  // us,
  // us1,
} from "../_components/Imagepath";
 import AWS from 'aws-sdk';
 import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";

const Header = (props) => {
  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };

  

  const onMenuClik = () => {
    // eslint-disable-next-line react/prop-types
    props.onMenuClick();
  };

  useEffect(() => {
    const handleClick = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    };

    const maximizeBtn = document.querySelector(".win-maximize");
    maximizeBtn.addEventListener("click", handleClick);

    return () => {
      maximizeBtn.removeEventListener("click", handleClick);
    };
  }, []);

let auth_profile_image = "";
const profile_image = localStorage.getItem("profile_image");

        //console.log("profile_image value from localStorage:", profile_image);
// extra guard: only use if it's a real, non-empty string
if (typeof profile_image === "string" && profile_image.trim() !== "" && profile_image !== "null" && profile_image !== "undefined") {
  AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: "v4",
  });

  const s3 = new AWS.S3();
  try {
    const params = { Bucket: AWS_BUCKET, Key: profile_image };
    auth_profile_image = s3.getSignedUrl("getObject", params);
  } catch (err) {
    console.error("Invalid S3 key:", profile_image, err);
    auth_profile_image = avatar07; // fallback
  }
} else {
  auth_profile_image = avatar07; // fallback if invalid
}

  return (
    <div className="header header-one">
      <Link
        to="/profile"
        className="d-inline-flex d-sm-inline-flex align-items-center d-md-inline-flex d-lg-none align-items-center device-logo"
      >
        <img src={logo} className="img-fluid logo2 main-logo-mbile" alt="Logo" />
      </Link>
      <div className="main-logo d-inline float-start d-lg-flex align-items-center d-none d-sm-none d-md-none">
        <div className="logo-white">
          <Link to="/profile">
            <img src={logo} className="img-fluid logo-blue" alt="Logo" style={{width:'60px'}}/>
          </Link>
          <Link to="/profile">
            <img
              src={logoSmallWhite}
              className="img-fluid logo-small"
              alt="Logo"
            />
          </Link>
        </div>
        <div className="logo-color">
          <Link to="/profile">
            <img src={logo} className="img-fluid logo-blue" alt="Logo 12"  />
          </Link>
          <Link to="/profile">
            <img src={logoSmall} className="img-fluid logo-small" alt="Logo" />
          </Link>
        </div>
      </div>
      {/* Sidebar Toggle */}
      <Link to="#" id="toggle_btn" onClick={handlesidebar}>
        <span className="toggle-bars">
          <span className="bar-icons" />
          <span className="bar-icons" />
          <span className="bar-icons" />
          <span className="bar-icons" />
        </span>
      </Link>
      {/* /Sidebar Toggle */}
      {/* Search */}
      <div className="top-nav-search header-swasonshow">
        <div className="season-name">{localStorage.getItem("season_name")}</div>
        <form style={{display:'none'}}>
          <input
            type="text"
            className="form-control"
            placeholder="Search here"
          />
          <button className="btn" type="submit">
            <img src={search} alt="img" />
          </button>
        </form>
        
      </div>
      {/* /Search */}
      {/* Mobile Menu Toggle */}
      <Link
        to="#"
        className="mobile_btn"
        id="mobile_btn"
        onClick={() => onMenuClik()}
      >
        <i className="fas fa-bars" />
      </Link>
 
      <ul className="nav nav-tabs user-menu">
      
        <li className="nav-item  has-arrow dropdown-heads ">
          <Link to="#" className="win-maximize">
            <i className="fe fe-maximize" />
          </Link>
        </li>
        {/* User Menu */}
        <li className="nav-item dropdown">
          <Link
            to="#"
            className="user-link  nav-link"
            data-bs-toggle="dropdown"
          >
            <span className="user-img">
              <img src={auth_profile_image} alt="img" className="profilesidebar" />
              <span className="animate-circle" />
            </span>
            <span className="user-content">
              <span className="user-details">Admin</span>
              <span className="user-name">{localStorage.getItem("auth_name")}</span>
            </span>
          </Link>
          <div className="dropdown-menu menu-drop-user">
            <div className="profilemenu">
              <div className="subscription-menu">
                <ul>
                  <li>
                    <Link className="dropdown-item" to="/profile">
                      Profile
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/change-password">
                      Settings
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="subscription-logout">
                <ul>
                  <li className="pb-0">
                    <Link className="dropdown-item" to="/logout">
                      Log Out
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
        {/* /User Menu */}
      </ul>
      {/* /Header Menu */}
    </div>
  );
};
export default Header;
